import {DatePickerPopoverSingleDateInput} from "@/components/datePicker/subComponents/DatePickerPopoverSingleDateInput/DatePickerPopoverSingleDateInput.tsx";
import {DatePickerPopoverSingleDateRangeInputProps} from "@/components/datePicker/subComponents/DatePickerPopoverSingleDateRangeInput/DatePickerPopoverSingleDateRangeInput.types.ts";
import {
  RangeEndInputValidator,
  RangeStartInputValidator,
} from "@/components/datePicker/subComponents/DatePickerPopoverSingleDateRangeInput/DatePickerPopoverSingleDateRangeInput.utils.ts";
import {DateFormatName} from "@/lib/types/common.ts";
import {endOfDay} from "date-fns";
import {DateRange} from "react-day-picker";

export const DatePickerPopoverSingleDateRangeInput = ({
  type,
  dateRange,
  dateFormat = DateFormatName.DEFAULT,
  timeFormat,
  mode,
  splitRole,
  onChange,
  ...rest
}: DatePickerPopoverSingleDateRangeInputProps) => {
  const dateRangeAccessor = type === "start" ? "from" : "to";
  return (
    <DatePickerPopoverSingleDateInput
      initialDate={dateRange ? dateRange[dateRangeAccessor] : undefined}
      dateFormat={dateFormat}
      timeFormat={timeFormat}
      placeholder={type === "start" ? "Start Date" : "End Date"}
      disabled={
        (mode === "split" && splitRole === "end" && type === "start") ||
        (mode === "split" && splitRole === "start" && type === "end")
      }
      validators={
        type === "start"
          ? [RangeStartInputValidator(dateRange as DateRange)]
          : [RangeEndInputValidator(dateRange as DateRange)]
      }
      onChange={(_, date) => {
        if (!date) {
          onChange?.({
            from: type === "start" ? undefined : (dateRange as DateRange)?.from,
            to: type === "end" ? undefined : (dateRange as DateRange)?.to,
          });
          return;
        }
        if (type === "start" && dateRange?.to && date > dateRange?.to) {
          console.warn("Start date cannot be after end date");
          return;
        }
        if (type === "end" && dateRange?.from && date < dateRange?.from) {
          console.warn("End date cannot be before start date");
          return;
        }
        onChange?.({
          from: type === "start" ? date : (dateRange as DateRange)?.from,
          to: type === "end" ? endOfDay(date) : (dateRange as DateRange)?.to,
        });
      }}
      {...rest}
    />
  );
};
